export const outOfStockDrugError = [{
    drug: 'Champix Starter pack',
    message: 'Out of Stock (ETA 2024). Please empty the input and search another drug.'
}];
